import infoDirective from "./info-directive";

export {infoDirective};
